import { render } from "./AppCardRecipe.vue?vue&type=template&id=568d6b94&scoped=true"
import script from "./AppCardRecipe.vue?vue&type=script&lang=js"
export * from "./AppCardRecipe.vue?vue&type=script&lang=js"

import "./AppCardRecipe.vue?vue&type=style&index=0&id=568d6b94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568d6b94"]])

export default __exports__